@if (label()) {
  <span
    class="label"
    [id]="labelId">
    {{ label() }}
    @if (required()) {
      <span
        class="required"
        aria-hidden="true">
        *
      </span>
    }
  </span>
}

<div
  #field
  class="trigger"
  [class.open]="expanded()"
  [class.error]="hasError()"
  [class.disabled]="disabled()"
  [class.clearable]="showClear()">
  @if (searchable()) {
    <input
      ngCombobox
      class="control search"
      [class.has-value]="hasSelection()"
      [placeholder]="inputPlaceholder()"
      [attr.aria-labelledby]="labelledBy()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-required]="required()"
      [disabled]="disabled()"
      [(value)]="query"
      [(expanded)]="expanded"
      [preserveContent]="true"
      (click)="open()"
      (focusout)="touch.emit()" />
  } @else {
    <div
      ngCombobox
      class="control"
      [attr.aria-labelledby]="labelledBy()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-required]="required()"
      [disabled]="disabled()"
      [(expanded)]="expanded"
      [preserveContent]="true"
      (focusout)="touch.emit()">
      <span
        class="text"
        [class.placeholder]="!hasSelection()">
        {{ displayText() }}
      </span>
    </div>
  }

  @if (showClear()) {
    <button
      type="button"
      class="clear"
      aria-label="Clear selection"
      (click)="clear()">
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true">
        <path d="M7 7l10 10M17 7L7 17" />
      </svg>
    </button>
  }

  <svg
    class="chevron"
    viewBox="0 0 24 24"
    aria-hidden="true">
    <path d="M7 10l5 5 5-5" />
  </svg>
</div>

@if (combobox(); as combobox) {
  <ng-template
    [cdkConnectedOverlay]="{ origin: field, usePopover: 'inline', matchWidth: matchWidth() }"
    [cdkConnectedOverlayOpen]="expanded()">
    <ng-template
      ngComboboxPopup
      [combobox]="combobox">
      <div
        class="popup"
        [class.match-width]="matchWidth()">
        <div
          ngListbox
          ngComboboxWidget
          #listbox="ngListbox"
          class="listbox"
          focusMode="activedescendant"
          selectionMode="explicit"
          [tabindex]="-1"
          [value]="selectedValues()"
          [activeDescendant]="listbox.activeDescendant()"
          (valueChange)="select($event)"
          (click)="close()"
          (keydown.enter)="close()"
          (keydown.space)="close()">
          @for (option of visibleOptions(); track option.value) {
            <div
              ngOption
              class="option"
              [value]="option.value"
              [label]="option.label"
              [disabled]="option.disabled">
              <span class="text">
                {{ option.label }}
                @if (option.description) {
                  <span class="description">{{ option.description }}</span>
                }
              </span>

              <svg
                class="check"
                viewBox="0 0 24 24"
                aria-hidden="true">
                <path d="M5 12.5l4.5 4.5L19 7.5" />
              </svg>
            </div>
          } @empty {
            <div class="empty">{{ emptyText() }}</div>
          }
        </div>
      </div>
    </ng-template>
  </ng-template>
}
